import React, { Component } from 'react';
import '../styles/commentaires.css';
import { getComments } from '../services/commentsService';
import qs from "qs";
import {
  Box,
  Paper,
  Stack,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Pagination,
  Link as MuiLink,
  Tooltip
} from '@mui/material';

class Commentaires extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hits: [],
      page: 1,
      total_elem: 0,
      isLoading: false,
      q: '',
      author: ''
    };
    this.fetchPage = this.fetchPage.bind(this);
    this.onSearchSubmit = this.onSearchSubmit.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
  }

  componentDidMount() {
    const parsed = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    this._isMounted = true;
    this.setState({ author: parsed.author || '' }, () => this.fetchPage(1, '', this.state.author));
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onSearchSubmit(e) {
    e.preventDefault();
    this.fetchPage(1, this.state.q, this.state.author);
  }

  onPageChange(e, value) {
    this.fetchPage(value, this.state.q, this.state.author);
  }

  fetchPage(page, q, author) {
    this.setState({ isLoading: true });
    getComments(q || '', page, author || '')
      .then((result) => {
        if (!this._isMounted) return;
        const total = (parseFloat(result.total_elem_approved) || 0) + (parseFloat(result.total_elem_deleted) || 0) + (parseFloat(result.total_elem_pending) || 0);
        this.setState({
          hits: result.comments || [],
          page: parseFloat(result.page_nbr) || page,
          total_elem: total,
          isLoading: false
        });
      })
      .catch(() => this.setState({ isLoading: false }));
  }

  render() {
    const { hits, page, total_elem, q } = this.state;
    const pageCount = Math.max(1, Math.ceil((total_elem || 0) / 10));

    return (
      <Box sx={{ p: 2 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
          <Typography variant="h6">Commentaires</Typography>
          <Box component="form" onSubmit={this.onSearchSubmit} sx={{ display: 'flex', gap: 1, width: { xs: '100%', sm: 'auto' } }}>
            <TextField
              size="small"
              placeholder="Rechercher…"
              value={q}
              onChange={(e) => this.setState({ q: e.target.value })}
            />
            <Button variant="contained" type="submit">Search</Button>
          </Box>
        </Stack>

        <Paper variant="outlined">
          <TableContainer sx={{ maxHeight: '70vh' }}>
            <Table
              size="medium"
              stickyHeader
              sx={{
                tableLayout: 'fixed',
                '& tbody tr:nth-of-type(odd)': { bgcolor: 'action.hover' }
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Content</TableCell>
                  <TableCell>Website</TableCell>
                  <TableCell>Thread</TableCell>
                  <TableCell>Url</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Hide</TableCell>
                  <TableCell>Shadow</TableCell>
                  <TableCell>Pinned</TableCell>
                  <TableCell>Created</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {hits.map((item) => (
                  <TableRow key={item._id} hover>
                    <TableCell sx={{ width: { xs: 160, md: 260 } }}>
                      <Tooltip title={item._id}>
                        <Typography variant="body2" sx={{ fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                          {item._id}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ width: { xs: 220, md: 420 } }}>
                      <Tooltip title={item.content || ''}>
                        <Typography variant="body2" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                          {item.content}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell>{item.website}</TableCell>
                    <TableCell>{item.thread? item.thread._id : ''}</TableCell>
                    <TableCell>
                      <MuiLink href={`${item.thread ? item.thread.url : ''}?comment_id=${item._id}`} underline="hover" target="_blank" rel="noopener">
                        Ouvrir
                      </MuiLink>
                    </TableCell>
                    <TableCell>{item.status}</TableCell>
                    <TableCell>{String(item.hide)}</TableCell>
                    <TableCell>{String(item.shadow)}</TableCell>
                    <TableCell>{String(item.pinned)}</TableCell>
                    <TableCell>{item.created_at}</TableCell>
                  </TableRow>
                ))}
                {hits.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <Typography variant="body2" color="text.secondary">Aucune donnée</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="caption" color="text.secondary">Page {page} / {pageCount}</Typography>
            <Pagination
              page={page}
              count={pageCount}
              onChange={this.onPageChange}
              size="small"
              color="primary"
              showFirstButton
              showLastButton
            />
          </Box>
        </Paper>
      </Box>
    );
  }
}

export default Commentaires;